import VueRouter from 'vue-router';
import { sync } from 'vuex-router-sync';
import store            from './store';
import helpers          from 'helpers';
import windowManager    from 'manager/window-manager';
import WebPushManager   from 'manager/WebPushManager';
import DbManager        from 'manager/DbManager';
import GaManager        from 'manager/GaManager';
import OldModuleManager from 'manager/old-modules';



const router = new VueRouter({
  mode    : 'history',
  fallback: false,
});

const unsync = sync(store, router);

const dnSettings = {
  router,
  store,

  components: {
    'dn-db-manager': DbManager,
  },

  data() {
    return {
    }
  },

  computed: {
    attributeDialog() { return this.$refs.attributeDialog },
    loading() { return this.$refs.loading },
    db() { return this.$refs.dbManager },
  },

  methods: {
    async init() {
      this.push.load();

      await this.segments.ready();
      if (!this.segments.userType.get()) {
        this.attributeDialog.show();
      }

      // タブレットの場合はviewportをアジャストする
      if (this.$store.getters['ua/is']('tablet')) this.window.viewportAdjust();
      this.emit('init');
    },
    ready() {
      return new Promise(resolve => {
        this.hasAndOne('mount', resolve);
      });
    },

    debug() {
      const scriptPath = this.$store.getters['path/$join']('resources', 'js/debugger.js');
      this.$http.get(scriptPath);
    },

    checkLoginStatus() {
      // if (this.$store.getters['config/envIs']('develop')) return;
      if(!this.$store.getters['config/isManabi']) return;

      let currentUrl = this.$route.fullPath;

      if( currentUrl.includes('center/home') ||
          currentUrl.includes('jikosaiten/index.html') ||
          currentUrl.includes('jikosaiten/hantei') ||
          currentUrl.includes('center/bible/mock') ||
          currentUrl.includes('center/bible/myuniv') ||
          currentUrl.includes('center/bible/search')
      ){
        let memberTypeKey = this.segments.cookies.get('member_type_key');
        // let gaValue = this.segments.cookies.get('ga-value03');
        // マナビ認証
        if(memberTypeKey !== '"RElHSQ=="') {
          // 認証無しの場合はマナビジョンログイン画面へ遷移
          window.location.href = 'https://manabi.benesse.ne.jp/wi/jsp/gy1_toroku/login_failure.jsp';
        // } else if(gaValue !== "3" && gaValue !== "4") { // 学年判定
        //   // 高校3年、既卒以外の場合はマナビジョンTOPへ遷移
        //   alert('マナビジョンCompassは高校3年生より使用可能となります');
        //   window.location.href = 'https://manabi.benesse.ne.jp/';
        }
        // メアド登録認証対応
        // DN2021ではメアド登録必須を外す DN_2021-97
        /**
        window.fetch(
          "https://manabi.benesse.ne.jp/cmp/services/public/stdtShibokoInfo",
          {
            credentials: "include",
            headers: {
              "Accept": "application/json",
              "Content-Type": "application/json"
            },
            referrer: "https://dn-sundai.benesse.ne.jp/manabi/",
            referrerPolicy: "no-referrer-when-downgrade",
            body: "{\"serviceId\":2,\"examId\":\"20200118K3DN2020308_\"}",
            method: "POST",
            mode: "cors"
        }).then(() => {
          console.log("メールアドレス認証OK");
        //   // 参照した登録志望校情報をcookieに書き込み
        //   return shiboko_response.json();
        // }).then(res => {
        //   if (!res.stdt.seiseki.details.shiboList.cmpsSiboList) {
        //     return;
        //   }
        //   const shibokoList = res.stdt.seiseki.details.shiboList.cmpsSiboList;
        //   var schoolChoices = "";
        //   shibokoList.forEach(ary => {
        //     schoolChoices += ary.bosyutaniCd + "_";
        //   });
        //   // 末尾の'_'を削除
        //   schoolChoices = schoolChoices.substring(0,schoolChoices.length-1);
        //   this.segments.cookies.set('bcs_1_2019_school_choices', schoolChoices);
        }).catch(() => {
          // 通信失敗
          console.log("メールアドレス認証NG");
          // OK押下でメールアドレス登録画面へ遷移
          alert("マナビジョンCompassをご活用いただくにはメールアドレス登録が必要です");
          window.location.href = 'https://manabi.benesse.ne.jp/wi/portfolio/agree/InputAction.do';
        });
        */
      }
    }
  },

  mounted() {
    new OldModuleManager();
    this.emit('mount');
  },

  created() {
    new EventManager(this);

    Object.defineProperty(this, 'h', {
      get() { return this.helpers }
    });

    this.banner     = window.bcBanner;
    this.segments   = this.banner.segments;

    // Initialize segments
    this.banner.setYear(DN_YEAR);
    this.$store.dispatch('segments/init');

    this.push       = new WebPushManager();
    this.helpers    = helpers;
    this.window     = windowManager;
    this.ga         = new GaManager(this);

    if (this.$store.getters['config/envIs']('develop')) {
      this.debug();
    }

    this.init();
    this.checkLoginStatus();
  },
};



export default dnSettings;


// WEBPACK FOOTER //
// ./src/js/dn.js